var knownSavvyAdvertisers = [
    {
        id: "mercuryinsurance",
        name: "Mercury Insurance",
    },
    {
        id: "pgrhome",
        name: "Progressive HomeQuote Explorer",
    },
    {
        id: "progressivehome",
        name: "Progressive Home",
    },
    {
        id: "hippo",
        name: "Hippo",
    },
];
function sanitizeName(name) {
    return name.toLowerCase();
}
export function findSavvyAdvertiser(displayName) {
    if (!displayName) {
        return;
    }
    var sanitizeDisplayName = sanitizeName(displayName);
    return knownSavvyAdvertisers.find(function (_a) {
        var name = _a.name;
        return sanitizeName(name) === sanitizeDisplayName;
    });
}
